import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    SPONSORSHIP_START_DATE,
    SPONSORSHIP_BONUS_AMOUNT,
    SPONSORSHIP_BONUS_PERCENT,
    SPONSORSHIP_PURCHASE_THRESHOLD,
    SPONSORSHIP_BOOSTED_BONUS_AMOUNT
} from '../../../constants/sponsorship';
import { PATH } from '../../../constants/path';
import { BRAND_NAME } from '../../../constants';

import { scrollToAnchor } from '../../../utils';
import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';

import { HeadComponent } from '../../HeadComponent';
import { withTemplate } from '../../template/withTemplate';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';
import LocalizedBreadcrumbItem from '../../breadcrumb/LocalizedBreadcrumbsItem';

import './TermsPage.scss';

class TermsPage extends React.Component {
    componentDidMount() {
        scrollToAnchor(this.props.location);
    }

    componentDidUpdate() {
        scrollToAnchor(this.props.location);
    }

    render() {
        const { i18n } = this.props;

        return (
            <main className="conteneur conteneur-mobile" id="p-cgu">
                <HeadComponent
                    title={convertHtmlToReactDomWithParams(i18n.TITLE, BRAND_NAME)}
                    description={i18n.DESCRIPTION}
                />
                <LocalizedBreadcrumbItem to={PATH.TERMS_PATH}>
                    {convertHtmlToReactDomWithParams(i18n.BREADCRUMB, BRAND_NAME)}
                </LocalizedBreadcrumbItem>
                <h1>{convertHtmlToReactDomWithParams(i18n.TITLE, BRAND_NAME)}</h1>
                <p>{i18n.EFFECTIVE_DATE}</p>

                <p>{i18n.TEXT0_1}</p>
                <p>{i18n.TEXT0_2}</p>
                <p>{i18n.TEXT0_3}</p>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT0_4)}</p>
                <p>{i18n.TEXT0_5}</p>
                <p>{i18n.TEXT0_6}</p>
                <p>{i18n.TEXT0_7}</p>
                <p>{i18n.TEXT0_8}</p>
                <p>{i18n.TEXT0_9}</p>
                <p>{i18n.TEXT0_10}</p>
                <p>{i18n.TEXT0_11}</p>
                <p>{i18n.TEXT0_12}</p>
                <p>{i18n.TEXT0_13}</p>
                <p>{i18n.TEXT0_14}</p>
                <p>{i18n.TEXT0_15}</p>
                <p>{i18n.TEXT0_16}</p>
                <p>{i18n.TEXT0_17}</p>
                <p>{i18n.TEXT0_18}</p>
                <p>{i18n.TEXT0_19}</p>
                <p>{i18n.TEXT0_20}</p>
                <p>{i18n.TEXT0_21}</p>
                <p>{i18n.TEXT0_22}</p>
                <p>{i18n.TEXT0_23}</p>
                <p>{i18n.TEXT0_24}</p>
                <p>{i18n.TEXT0_25}</p>
                <p>{i18n.TEXT0_26}</p>
                <p>{i18n.TEXT0_27}</p>
                <p>{i18n.TEXT0_28}</p>

                <h3>{i18n.TITLE1}</h3>
                <p>{i18n.TEXT1_1}</p>
                <p>{i18n.TEXT1_2}</p>
                <p>{i18n.TEXT1_3}</p>
                <p>{i18n.TEXT1_4}</p>

                <h3>{i18n.TITLE2}</h3>
                <p>{i18n.TEXT2_1}</p>

                <h3>{i18n.TITLE3}</h3>
                <p>{i18n.TEXT3_1}</p>
                <p>{i18n.TEXT3_2}</p>
                <p>{i18n.TEXT3_3}</p>
                <p>{i18n.TEXT3_4}</p>
                <p>{i18n.TEXT3_5}</p>
                <p>{i18n.TEXT3_6}</p>
                <p>{i18n.TEXT3_7}</p>

                <h3>{i18n.TITLE4}</h3>
                <p>{i18n.TEXT4_1}</p>
                <p>{i18n.TEXT4_2}</p>
                <p>{i18n.TEXT4_3}</p>
                <p>{i18n.TEXT4_4}</p>
                <p>{i18n.TEXT4_5}</p>
                <p>{i18n.TEXT4_6}</p>
                <p>{i18n.TEXT4_7}</p>
                <p>{i18n.TEXT4_8}</p>

                <h3>{i18n.TITLE5}</h3>
                <p>{i18n.TEXT5_1}</p>
                <p>{i18n.TEXT5_2}</p>
                <p>{i18n.TEXT5_3}</p>
                <p>{i18n.TEXT5_4}</p>
                <p>{i18n.TEXT5_5}</p>
                <p>{i18n.TEXT5_6}</p>
                <p>{i18n.TEXT5_7}</p>

                <h3>{i18n.TITLE6}</h3>
                <p>{i18n.TEXT6_1}</p>
                <p>{i18n.TEXT6_2}</p>
                <p>{i18n.TEXT6_3}</p>
                <p>{i18n.TEXT6_4}</p>
                <p>{i18n.TEXT6_5}</p>
                <p>{i18n.TEXT6_6}</p>

                <h3>{i18n.TITLE7}</h3>
                <p>{i18n.TEXT7_1}</p>
                <p>{i18n.TEXT7_2}</p>

                <h3>{i18n.TITLE8}</h3>
                <p>{i18n.TEXT8_1}</p>

                <h3>{i18n.TITLE9}</h3>
                <p>{i18n.TEXT9_1}</p>
                <p>{i18n.TEXT9_2}</p>

                <h3>{i18n.TITLE10}</h3>
                <p>{i18n.TEXT10_1}</p>

                <h3>{i18n.TITLE11}</h3>
                <p>{i18n.TEXT11_1}</p>
                <p>{i18n.TEXT11_2}</p>
                <p>{i18n.TEXT11_3}</p>

                <h3>{i18n.TITLE12}</h3>
                <p>{i18n.TEXT12_1}</p>
                <p>
                    {convertHtmlToReactDomWithParams(
                        i18n.TEXT12_2,
                        SPONSORSHIP_START_DATE,
                        SPONSORSHIP_BONUS_AMOUNT,
                        SPONSORSHIP_PURCHASE_THRESHOLD,
                        SPONSORSHIP_BONUS_PERCENT,
                        SPONSORSHIP_START_DATE
                    )}
                </p>
                <p>{i18n.TEXT12_3}</p>
                <ul>
                    <li>
                        {convertHtmlToReactDomWithParams(
                            i18n.TEXT12_4,
                            SPONSORSHIP_BOOSTED_BONUS_AMOUNT,
                            SPONSORSHIP_BONUS_AMOUNT,
                            SPONSORSHIP_PURCHASE_THRESHOLD
                        )}
                    </li>
                    <li>
                        {convertHtmlToReactDomWithParams(i18n.TEXT12_5, SPONSORSHIP_BONUS_PERCENT)}
                    </li>
                </ul>
                <p>{i18n.TEXT12_6}</p>
                <p>{i18n.TEXT12_7}</p>
                <p>{i18n.TEXT12_8}</p>
                <p>{i18n.TEXT12_9}</p>
                <p>{i18n.TEXT12_10}</p>
                <p>{i18n.TEXT12_11}</p>
                <p>{i18n.TEXT12_12}</p>

                <h3>{i18n.TITLE13}</h3>
                <p>{i18n.TEXT13_1}</p>
            </main>
        );
    }
}

TermsPage.propTypes = {
    i18n: PropTypes.object.isRequired
};

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
    return {
        i18n: state.i18n.page.TERMS
    };
}

export default withTemplate(connect(mapStateToProps)(TermsPage), PrimaryTemplate);



// WEBPACK FOOTER //
// ./src/components/pages/terms/TermsPage.js